// The width of side panel, e.g. sections panel
export const SIDE_PANEL_WIDTH = 492;

// The visible width of the last panel (concertina layout)
export const SIDE_PANEL_OVERHANG_WIDTH = 24;

// The height of top toolbar
export const TOOL_BAR_HEIGHT = 64;

// Left and Right border space for PDF content
export const PDF_CONTENT_MARGIN = 40;

export const BREAKPOINT_MOBILE_IN_PX = 576;
export const BREAKPOINT_X_LARGE_IN_PX = 1200;

// By default, not showing anything
export const DEFAULT_PAGE_SIZE = {
  width: 0,
  height: 0,
};

export const DEFAULT_CLIENT_HEIGHT = 10000;

export const IMAGE_DOWNSAMPLED = 'IMAGE-DOWNSAMPLED';

export const IMAGE_HIGH_RES = 'IMAGE-HIGH-RES';

export const DIRECTION = {
  ASC: 'ASC',
  DESC: 'DESC',
};

// Scale based on pdf file size
export const DEFAULT_SCALES = {
  SMALL_SCREEN: 1.395,
  LARGE_SCREEN: 1.8,
};

// PDF.js viewer variable
export const CSS_UNITS = 96.0 / 72.0;

export const MIN_SCALE_FOR_SIBLING_EXTRA_TEXT = 0.96;

export const KEYCODE_F3 = 114;
export const KEYCODE_F = 70;
export const KEYCODE_ESC = 27;
export const KEYCODE_ENTER = 13;

// Div id's used in javascript and CSS
export const PRINT_STATUS_CLOSE_BUTTON_ID = 'print-status-close-button';

export const PANEL_CLOSE_BUTTON_CLASS = 'panel-close-button';
export const SUPPORTED_PRINT_CLASS = 'supported-print';

// the css transition value for sidepanel to appear/disappear
export const SIDE_PANEL_TRANSITION = 300;

export const HELP_LINK = {
  BROWSER_EXTENSION: 'https://service.elsevier.com/app/answers/detail/a_id/29416/supporthub/mendeley/p/16086/',
  WEB: 'https://service.elsevier.com/app/answers/detail/a_id/17829/supporthub/sciencedirect/',
};
